"use strict";

(function($) {
    $(function() {

        $('.accordion__title').click(function(){
            $('.plus', this).toggleClass('is-opened');
            $(this).parents('.accordion__item').find('.accordion__content').slideToggle('200');
        });

    });
})(jQuery);
